/*
  # News Admin Page
  
  1. Changes
    - Created admin page for managing news posts
    - Added breadcrumb navigation
    - Integrated with admin layout
*/

import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import NewsPostsList from '../../components/admin/NewsPostsList';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const News = () => {
  return (
    <AdminLayout>
      <div className="p-8">
        {/* Breadcrumbs */}
        <div className="flex items-center gap-2 mb-8 text-sm">
          <Link to="/kh-admin" className="text-white/70 hover:text-white transition-colors">
            <Home className="w-4 h-4" />
          </Link>
          <ChevronRight className="w-4 h-4 text-white/40" />
          <span className="text-white">News & Updates</span>
        </div>

        <h1 className="text-3xl font-bold mb-8">News & Updates Management</h1>
        <NewsPostsList />
      </div>
    </AdminLayout>
  );
};

export default News;